import React, { createContext, useCallback, useContext, useState } from 'react';

const DashboardRefreshContext = createContext({
  refreshKey: 0,
  refresh: () => {},
});

export const DashboardRefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <DashboardRefreshContext.Provider value={{ refreshKey, refresh }}>
      {children}
    </DashboardRefreshContext.Provider>
  );
};

export const useDashboardRefresh = () => useContext(DashboardRefreshContext);

